var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4GiftGiftItDigitally = function Svg4GiftGiftItDigitally(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M11.217 20.323H54.26v9.456H11.217zm41.542 1.5H12.717v6.456H52.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M28.983 20.323h8.425v9.456h-8.425zm6.925 1.5h-5.425v6.456h5.425z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "m31.37 21.814-1.168-.783a18.8 18.8 0 0 0-11.722-3.134q.002.14-.006.293c-.015.652-.047 2.01.288 2.346l-1.06 1.061c-.79-.79-.756-2.26-.728-3.442a7 7 0 0 0-.006-.8c-.053-.265-.125-.627 1.049-3.726a114 114 0 0 1 1.123-2.835l.206-.5.541.04c1.449.15 2.873.476 4.241.972a14.1 14.1 0 0 1 7.113 5.216l.128.19zm-11.62-5.459c3.552 0 7.041.93 10.12 2.7v-1.889c-2.83-4-7.91-5.043-9.56-5.28-.677 1.664-1.358 3.47-1.676 4.5q.558-.032 1.116-.032z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M29.868 16.238h6.665v5.582h-6.665zm5.165 1.5h-3.665v2.582h3.665z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M35.027 21.814v-5.107l.128-.19a14.1 14.1 0 0 1 7.114-5.216 17.8 17.8 0 0 1 4.241-.972l.54-.04.207.5c.006.014.576 1.393 1.123 2.835 1.175 3.1 1.1 3.461 1.05 3.726a7 7 0 0 0-.007.805c.028 1.181.062 2.652-.727 3.441l-1.06-1.06c.335-.337.3-1.694.287-2.346 0-.1 0-.2-.006-.293a18.8 18.8 0 0 0-11.725 3.133zm1.5-4.644v1.89a20.3 20.3 0 0 1 11.24-2.674c-.318-1.025-1-2.83-1.679-4.5-1.144.17-2.268.45-3.357.84-2.47.82-4.633 2.37-6.204 4.444M13.724 28.28h38.52V55.67h-38.52zm37.02 1.5h-35.52V54.17h35.52z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M28.983 28.28h8.425V55.67h-8.425zm6.925 1.5h-5.425V54.17h5.425z"
  })));
};
export { Svg4GiftGiftItDigitally as ReactComponent };
export default "/_next/static/images/4gift-gift-it-digitally.svg";